import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b4862f96"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "center my-cards"
}
const _hoisted_2 = { class: "mb--22 my-cards__container-actions" }
const _hoisted_3 = { class: "my-cards__cards" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_5 = {
  key: 1,
  class: "my-cards"
}
const _hoisted_6 = { class: "mb--22 my-cards__container-actions" }
const _hoisted_7 = { class: "my-cards__cards residentialComplex" }
const _hoisted_8 = { class: "my-cards__cards-actions-btn items-in-line gap--3" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))

import { computed, onMounted, ref, Ref } from 'vue';
import { useAppStore } from '@/store/modules/app';
import { ResidentialComplexCard } from '@/components';
import LoadingResidentialComplexCard from '@/components/ResidentialComplexCard/LoadingResidentialComplexCard.vue';
import { useDevelopersStore } from '@/store/modules/developers';
import {
  CreateCategoryModalType,
  DeleteCategoryModalType,
  SmallCardLSDType,
} from '@/types';
import {
  CreateDeveloperModal,
  DeleteDeveloperModal,
} from '@/components/ProfileComponents';


export default /*#__PURE__*/_defineComponent({
  __name: 'MyResidentialComplex',
  setup(__props) {

const window = computed((): number => {
  return useAppStore().window;
});
const isLoading: Ref<boolean> = ref(false);
const residentialComplexes: Ref<SmallCardLSDType[]> = ref([]);

const createCategoryModalData: Ref<CreateCategoryModalType> = ref({
  show: false,
  categoryTitle: undefined,
});
const showCreateCategoryModal = (event: { categoryTitle: string }) => {
  createCategoryModalData.value = {
    show: true,
    categoryTitle: event.categoryTitle,
  };
};
const createCategory = async (event: { id: number; title: string; url: string }) => {
  residentialComplexes.value = [
    {
      id: String(event.id),
      developerTitle: event.title,
      coefficient: 0,
      title: '',
      logo: undefined,
      address: '',
      deadline: '',
      phone: '',
      coordinates: [],
      url: event.url,
    },
    ...residentialComplexes.value,
  ];
};

const closeCreateCategoryModal = () => {
  createCategoryModalData.value = {
    show: false,
    categoryTitle: undefined,
  };
};

const deleteCategoryModalData: Ref<DeleteCategoryModalType> = ref({
  show: false,
  id: undefined,
});
const showDeleteCategoryModal = (id: number) => {
  deleteCategoryModalData.value = {
    show: true,
    id: id,
  };
};
const closeDeleteCategoryModal = () => {
  deleteCategoryModalData.value = {
    show: false,
    id: undefined,
  };
};

const deleteCategory = async (id: number) => {
  residentialComplexes.value = residentialComplexes.value.filter(el => +el.id !== id);
};

onMounted(async () => {
  try {
    isLoading.value = true;
    const residentialComplexList = await useDevelopersStore().getResidentialComplexList();

    if (residentialComplexList) {
      residentialComplexes.value = residentialComplexList;
    }
  } finally {
    isLoading.value = false;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_base_skeleton_loader = _resolveComponent("base-skeleton-loader")!
  const _component_base_card = _resolveComponent("base-card")!
  const _component_base_icon = _resolveComponent("base-icon")!
  const _component_base_button = _resolveComponent("base-button")!

  return (isLoading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_base_card, {
          class: "my-cards__container",
          "full-width-mobile": ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              (_openBlock(), _createBlock(_component_base_skeleton_loader, {
                key: 2,
                styles: { width: '150px', height: '34px' },
                type: "text"
              }))
            ]),
            _createElementVNode("div", _hoisted_3, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (i) => {
                return _createElementVNode("div", {
                  key: i,
                  class: "my-cards__cards-item"
                }, [
                  _createVNode(LoadingResidentialComplexCard)
                ])
              }), 64))
            ]),
            _hoisted_4
          ]),
          _: 1
        })
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_5, [
        _createVNode(_component_base_card, {
          class: "my-cards__container",
          "full-width-mobile": ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("button", {
                class: "gradient-color",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (showCreateCategoryModal({ categoryTitle: 'ЖК' })))
              }, " Создать ЖК ")
            ]),
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(residentialComplexes.value.filter(el => el.url), (card) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: card.id,
                  class: "my-cards__cards-item"
                }, [
                  _createVNode(_unref(ResidentialComplexCard), {
                    project: card,
                    version: "v5"
                  }, null, 8, ["project"]),
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_base_button, {
                      href: { name: 'updateResidentialComplex', query: { id: card.id } },
                      bgColor: "#ffff",
                      icon: "",
                      "style-type": "border"
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_component_base_icon, { name: "edit" })
                      ]),
                      iconActive: _withCtx(() => [
                        _createVNode(_component_base_icon, {
                          color: "#009D3E",
                          name: "edit"
                        })
                      ]),
                      _: 2
                    }, 1032, ["href"]),
                    _createVNode(_component_base_button, {
                      bgColor: "#ffff",
                      icon: "",
                      "style-type": "border",
                      onClick: ($event: any) => (showDeleteCategoryModal(+card.id))
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_component_base_icon, { name: "delete" })
                      ]),
                      iconActive: _withCtx(() => [
                        _createVNode(_component_base_icon, {
                          color: "#009D3E",
                          name: "delete"
                        })
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ])
                ]))
              }), 128))
            ]),
            _hoisted_9
          ]),
          _: 1
        }),
        _createVNode(_unref(CreateDeveloperModal), {
          "create-category-modal-data": createCategoryModalData.value,
          isResidentialComplex: "",
          onClose: closeCreateCategoryModal,
          onCreateCategory: _cache[1] || (_cache[1] = ($event: any) => (createCategory($event)))
        }, null, 8, ["create-category-modal-data"]),
        _createVNode(_unref(DeleteDeveloperModal), {
          "delete-category-modal-data": deleteCategoryModalData.value,
          onClose: closeDeleteCategoryModal,
          onDeleteCategory: deleteCategory
        }, null, 8, ["delete-category-modal-data"])
      ]))
}
}

})